<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before: always;"></div>
<p class="P_Norm-Center__And__Page_Break" id="auto_bookmark_toc_1"><span>Pour les lecteurs de Dreamspun qui croient toujours au pouvoir de l’amour et aux fins les plus heureuses. Merci de m’avoir donné une place chaleureuse et douillette où je peux écrire les désirs de mon cœur.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0004.vue?062036ce